:host {
  display: block;
  @include cms-base-font-100;
  margin-bottom: var(--cms-components-mb);
  width: var(--cms-container-width);
}

.market-content {
  box-sizing: inherit;
  --cms-grid-gap: var(--cms-spacing-050);
  @include cms-default-grid-container;
}

.grid-item {
  grid-area: var(--cms-default-grid-area);
  color: var(--cms-semanticColors-base-strong-text);
}

.static-map-image {
  border-style: none;
  height: auto;
  width: 100%;
  vertical-align: middle;
}

.search-button {
  --cms-theme-border-color: var(--cms-semanticColors-base-strong-border);
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
  display: block;
  padding: var(--cms-spacing-075) 0;
}

cms-icon {
  align-items: center;
  margin-right: var(--cms-spacing-050);
}

.label {
  @include label-font-125;
}

.label,
.open-time-container,
.special-times-container,
.store-wrapper {
  margin-bottom: var(--cms-spacing-050);
}

.locator-wrapper,
.mail-wrapper,
.phone-wrapper {
  display: flex;
}

.open-days,
.date-label {
  padding-right: var(--cms-spacing-100);
  display: inline-block;
  min-width: 6.875rem;
}

.market-info-link {
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
  @include cms-anchor-base-font;
  text-underline-offset: 0.1875rem;
  text-decoration-thickness: 0.125rem;
}

.info-card {
  box-sizing: border-box;
  position: relative;
  background: var(--cms-semanticColors-container-weak-background);
  padding: var(--cms-spacing-075);

  & .market-info-link {
    --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
    @include cms-anchor-base-font;
  }
}

/* special styles for hdp dialog */
.static-map-container {
  width: 100%;
}

.static-map-container .hdp-container {
  width: 100% !important;
  padding: 0 !important;
}

@include media-width($breakpoint-xs) {
  .market-image {
    object-fit: contain !important;
  }
}

@include media-width($breakpoint-sm) {
  .market-content {
    gap: var(--cms-grid-gap);
  }

  .grid-item.address,
  .grid-item.open-times {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .grid-item.search-stores {
    --cms-default-grid-area: auto / auto / auto / span 12;
  }

  .grid-item.market-image-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .grid-item.static-map-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }
}

@include media-width($breakpoint-md) {
  .market-image {
    object-fit: inherit !important;
  }

  .google-maps-link {
    position: relative;
    top: -6.25rem;
  }

  .grid-item.address.hidden-search-stores,
  .grid-item.open-times.hidden-search-stores {
    --cms-default-grid-area: auto / auto / span 2 / span 3;
  }

  .grid-item.address,
  .grid-item.open-times {
    --cms-default-grid-area: auto / auto / auto / span 3;
  }

  .grid-item.search-stores {
    --cms-default-grid-area: 2 / auto / auto / span 6;
  }

  .grid-item.market-image-wrapper {
    --cms-default-grid-area: auto / auto / span 2 / span 6;
  }

  .grid-item.static-map-wrapper {
    max-height: 37.5rem;
    overflow: hidden;
    --cms-default-grid-area: auto / auto / auto / span 12;
  }
}